import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class DocGenConfigService extends RLBaseService {

    static $inject = ["$resource", "$q"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getDocTemplateTypes() {
        return this.toRLService<Models.IWFDocumentTemplateType>("/api/workflowconfig/getdoctemplatetypes").query().$promise;
    }

    getDocTemplatesByCharType(charTypeID: number) {
        var data = { charTypeID: charTypeID };
        return this.toRLService<Models.IDocTemplateConfig>("/api/docgenconfig/GetDocTemplatesByCharType").query(data).$promise;

    }

    saveAttachment(request: Models.IDocGenAttachmentRequest) {
        return this.toRLService<void>("/api/docgenconfig/saveattachment").post(request).$promise;
    }

    getCharTemplates(docTypeID: number) {
        var data = { docTypeID: docTypeID };
        return this.toRLService<Models.ICharTemplate>("/api/docgenconfig/GetCharTemplates").query(data).$promise;
    }

    getSelectedCharTypeTemplatesForDoc(docTemplateID: number) {
        var data = { docTemplateID: docTemplateID };
        return this.toRLService<number>("/api/docgenconfig/GetSelectedCharTypeTemplatesForDoc").query(data).$promise;
    }

    saveTemplate(request: Models.IDocTemplateSaveRequest) {
        return this.toRLService<Models.IDataResponse<number>>("/api/docgenconfig/SaveDocTemplate").post(request).$promise;
    }

    deleteDocTemplate(request: Models.IDocTemplateRequest) {
        return this.toRLService<void>("/api/docgenconfig/DeleteDocTemplate").post(request).$promise;
    }

    searchDocs(query: Models.ISearchRequest) {
        return this.toRLService<Models.IAssetSearchResult>("/api/docgen/search/").post(query).$promise;
    }

    validateDraftTemplate(request: Models.IDocTemplateValidationRequest) {
        return this.toRLService<Models.IDocTemplateValidationResult>("/api/docgenconfig/validateDocumentTemplate").post(request).$promise;
    }
}
